import { addToRecord, updateRecord } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  ThreadRepliesLayoutAction,
  ThreadStarterAttachmentsLayoutAction,
  ThreadStarterBodyLayoutAction,
} from '../../domains/threadSetLayout/actions.types';

import {
  AttachmentsCollapsingLayoutType,
  MessageBodyCollapsingLayoutType,
  ReplyCollapsingLayoutType,
  ThreadLayout,
  ThreadLayouts,
} from './types';

export type ThreadLayoutsAction =
  | ThreadStarterBodyLayoutAction
  | ThreadStarterAttachmentsLayoutAction
  | ThreadRepliesLayoutAction;

const initialState: ThreadLayouts = {};

const addOrUpdateThreadLayout = (
  state: ThreadLayouts,
  threadId: ThreadLayout['id'],
  newLayout: Partial<ThreadLayout>
) => {
  const existingLayout = state[threadId];

  if (existingLayout == null) {
    const defaultLayout = {
      threadStarterBody: MessageBodyCollapsingLayoutType.Collapsed,
      threadStarterAttachments: AttachmentsCollapsingLayoutType.Expanded,
      replies: ReplyCollapsingLayoutType.Expanded,
    };

    return addToRecord(state, threadId, {
      id: threadId,
      ...defaultLayout,
      ...newLayout,
    });
  }

  return updateRecord(state, threadId, {
    ...existingLayout,
    ...newLayout,
  });
};

const setThreadStarterBodyLayout = (
  state: ThreadLayouts,
  { threadId, layout }: ThreadStarterBodyLayoutAction['payload']
) =>
  addOrUpdateThreadLayout(state, threadId, {
    threadStarterBody: layout,
  });

const setThreadStarterAttachmentsLayout = (
  state: ThreadLayouts,
  { threadId, layout }: ThreadStarterAttachmentsLayoutAction['payload']
) =>
  addOrUpdateThreadLayout(state, threadId, {
    threadStarterAttachments: layout,
  });

const setThreadRepliesLayout = (state: ThreadLayouts, { threadId, layout }: ThreadRepliesLayoutAction['payload']) =>
  addOrUpdateThreadLayout(state, threadId, {
    replies: layout,
  });

const reducer: Reducer<ThreadLayouts, ThreadLayoutsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD_STARTER.BODY_LAYOUT_SET':
      return setThreadStarterBodyLayout(state, action.payload);
    case 'THREAD_STARTER.ATTACHMENTS_LAYOUT_SET':
      return setThreadStarterAttachmentsLayout(state, action.payload);
    case 'THREAD.REPLIES_LAYOUT_SET':
      return setThreadRepliesLayout(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
